import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router';
import Spinner from 'UI/Elements/Spinner';
import auth from 'lib/authentication';
var Logout = /*#__PURE__*/function (_Component) {
  function Logout(props) {
    var _this;
    _classCallCheck(this, Logout);
    _this = _callSuper(this, Logout, [props]);
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return auth.logout();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _this.state = {
      loading: false
    };
    return _this;
  }
  _inherits(Logout, _Component);
  return _createClass(Logout, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "loading-page-overview"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);
}(Component);
export default withRouter(Logout);